/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectWifiIcon16Solid = forwardRef('NetConnectWifiIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.001 4.5a7.5 7.5 0 0 0-5.607 2.518A1 1 0 0 1 .9 5.689a9.5 9.5 0 0 1 14.204.002 1 1 0 1 1-1.495 1.329A7.5 7.5 0 0 0 8 4.5Z" }),
        React.createElement("path", { d: "M8.003 8.5a3.5 3.5 0 0 0-2.739 1.317 1 1 0 1 1-1.563-1.248 5.5 5.5 0 0 1 8.604.008 1 1 0 1 1-1.565 1.245A3.5 3.5 0 0 0 8.003 8.5Z" }),
        React.createElement("path", { d: "M8 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" })));
});
